// Centralized environment configuration for URLs and environment flags

export const NODE_ENV = import.meta.env.MODE;
export const IS_DEV = import.meta.env.DEV;

// Backend API base URL
const API_BASE_URL_FROM_ENV = import.meta.env.VITE_API_BASE_URL as string | undefined;
export const API_BASE_URL =
  API_BASE_URL_FROM_ENV && API_BASE_URL_FROM_ENV.length > 0
    ? API_BASE_URL_FROM_ENV
    : IS_DEV
    ? 'http://localhost:8080'
    // : 'https://gsr-dt-api-p001-qa.azurewebsites.net';
    : 'https://gsr-dt-api-p001.azurewebsites.net';
    

// Frontend application redirect URL (MSAL redirect)
const APP_REDIRECT_URL_FROM_ENV = import.meta.env.VITE_REDIRECT_URL as string | undefined;
export const APP_REDIRECT_URL =
  APP_REDIRECT_URL_FROM_ENV && APP_REDIRECT_URL_FROM_ENV.length > 0
    ? APP_REDIRECT_URL_FROM_ENV
    : IS_DEV
    ? 'http://localhost:3000/redirct'
    : 'https://ari.gsrdt.com/redirct';
    // : 'https://gsr-dt-app-p002-qa.azurewebsites.net/redirct';

// Microsoft Graph API base URL
const GRAPH_API_BASE_URL_FROM_ENV = import.meta.env.VITE_GRAPH_API_BASE_URL as string | undefined;
export const GRAPH_API_BASE_URL =
  GRAPH_API_BASE_URL_FROM_ENV && GRAPH_API_BASE_URL_FROM_ENV.length > 0
    ? GRAPH_API_BASE_URL_FROM_ENV
    : 'https://graph.microsoft.com';


